import { FC } from 'react';

import LoginButton from '../AuthButtons/LoginButton';

import AuthQuestionBlock from './AuthQuestionBlock';

const HaveAccountQuestion: FC = () => (
  <AuthQuestionBlock>
    Already have an account?{' '}
    <LoginButton variant="blue-link" size="link-medium" />
  </AuthQuestionBlock>
);

export default HaveAccountQuestion;
